module.exports = __webpack_public_path__ + "static/media/icon_calendar.f3ecb057.svg";